export function isSet(value: unknown): value is NonNullable<unknown> {
	if (typeof value === 'boolean') { return true; } // Booleans are considered set
	return value !== null && typeof value !== 'undefined';
}
